import { useState, useMemo } from 'react';

import { ScreenReaderOnly } from 'approot/shared/styles/global.styles';
import { LinkButton } from '../styles/buttons/link-button.style';
import { splitText } from './read-more.utils';
import * as Styled from './read-more.style';

type Props = {
  content: string;
  contentType: string;
  previewWordCount?: number;
  marginBottom?: number;
};

const ReadMore = ({
  content,
  previewWordCount = 30,
  marginBottom = 32,
  contentType,
}: Props) => {
  const [isPreview, setIsPreview] = useState<boolean>(true);

  const [preview, remainingText] = useMemo<[string, string]>(
    () => splitText(content, previewWordCount),
    [content, previewWordCount]
  );

  const hasMoreText = !!remainingText;

  return (
    <Styled.ReadMoreParagraph marginBottom={marginBottom}>
      <Styled.ReadMoreContent isPreview={hasMoreText && isPreview}>
        <span>{preview}</span>
        {hasMoreText && isPreview && (
          <ScreenReaderOnly as="span">
            This is a preview. More content can be revealed.
          </ScreenReaderOnly>
        )}
        {!isPreview && <span>{remainingText}</span>}
      </Styled.ReadMoreContent>
      {hasMoreText && (
        <LinkButton
          type="button"
          onClick={() => setIsPreview(!isPreview)}
          aria-label={`${isPreview ? 'Show' : 'Hide'} text for ${contentType}`}
        >
          {isPreview ? 'Read More' : 'Read Less'}
        </LinkButton>
      )}
    </Styled.ReadMoreParagraph>
  );
};

export default ReadMore;
